import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import { useCaseMap } from '../utils/useCase/useCaseMap'
import Playground from '@/views/playground/Playground'
import { parseJwt } from './jwtParser'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter: (to, from, next) => {
        next({ path: '/map/realtime' })
      }
    },
    {
      path: '/reports/:slug',
      name: 'GenericReportsPage',
      props: true,
      component: () =>
        import(/* webpackChunkName: "vts-generic-reports-page" */ '../views/ReportsPage'),
      beforeEnter: (to, from, next) => {
        const allowedValues = ['incident', 'all']
        const exists = allowedValues.includes(to.params.slug.toLowerCase())

        if (exists) {
          next()
        } else {
          next({ name: '404' })
        }
      }
    },
    {
      path: '/restcrud/:page',
      name: 'RestCrud',
      props: true,
      component: () =>
        import(/* webpackChunkName: "vts-generic-reports-page" */ '../components/v2/restpages/RestCrudPage')
    },
    {
      path: '/settings/:page',
      name: 'Settings',
      props: true,
      component: () =>
        import(/* webpackChunkName: "vts-generic-reports-page" */ '../components/v2/restpages/RestCrudPage')
    },
    {
      path: '/map/:slug',
      name: 'GenericMapPage',
      props: true,
      component: () =>
        import(/* webpackChunkName: "vts-map-page" */ '../views/MapPage'),
      beforeEnter: (to, from, next) => {
        const allowedMapValues = [
          'poi',
          'routehistory',
          'realtime',
          'retroactivepoi',
          'incident',
          'optimization',
          'weightoptimization'
        ]
        const exists = allowedMapValues.includes(to.params.slug.toLowerCase())

        if (exists) {
          next()
        } else {
          next({ name: '404' })
        }
      }
    },
    {
      path: '/playground',
      name: 'playground',
      component: Playground,
      meta: {
        title: 'Playground'
      }
    },
    {
      path: '/serviceSchedules',
      name: 'ServiceSchedules',
      component: () =>
        import(/* webpackChunkName: "service-schedule" */ '../views/serviceBook/ServiceSchedules'),
      meta: {
        title: 'Service Schedules'
      }
    },
    {
      path: '/probeCalibration',
      name: 'ProbeCalibration',
      component: () =>
        import(/* webpackChunkName: "service-schedule" */ '../views/ProbeCalibrationPage'),
      meta: {
        title: 'Probe calibration'
      }
    },
    {
      path: '/zobs',
      name: 'Zobs',
      component: () =>
        import(/* webpackChunkName: "zobs" */ '../views/ZobsPage'),
      meta: {
        title: 'Zobs'
      }
    },
    {
      path: '/driversRanking',
      name: 'DriversRanking',
      component: () =>
        import(/* webpackChunkName: "drivers-ranking" */ '../views/DriversRankingPage'),
      meta: {
        title: 'Drivers Ranking'
      }
    },
    {
      path: '/customReports',
      name: 'CustomReports',
      component: () =>
        import(/* webpackChunkName: "service-schedule" */ '../views/CustomReportsPage'),
      meta: {
        title: 'Custom Reports'
      }
    },
    {
      path: '/mileageCleanaup',
      name: 'MileageCleanup',
      component: () =>
        import(/* webpackChunkName: "mileage-cleanup" */ '../views/MileageCleanupPage'),
      meta: {
        title: 'Mileage Cleanup'
      }
    },
    {
      path: '/serviceRealization',
      name: 'ServiceRealization',
      component: () =>
        import(/* webpackChunkName: "service-schedule" */ '../views/serviceBook/ServiceRealization'),
      meta: {
        title: 'Service Realization'
      }
    },
    {
      path: '/graphs',
      name: 'Graphs',
      component: () =>
        import(/* webpackChunkName: "service-schedule" */ '../views/graphs/CustomGraph'),
      meta: {
        title: 'Custom Graph'
      }
    },
    {
      path: '/usecases',
      name: 'UseCases',
      component: () =>
        import(/* webpackChunkName: "vts-use-case-page" */ '../views/usecases/UseCases'),
      meta: {
        title: 'UseCases'
      }
    },
    {
      path: '/dispatchNotes',
      name: 'DispatchNotes',
      component: () =>
        import(/* webpackChunkName: "dispatch-notes" */ '../views/optimization/DispatchNotes'),
      meta: {
        title: 'Dispatch Notes'
      }
    },
    {
      path: '/login',
      name: 'locallogin',
      meta: {
        title: 'Login',
        layout: 'no-header',
        meta: {
          title: 'locallogin'
        }
      },
      component: () =>
        import(/* webpackChunkName: "vts-login-page" */ '@/views/login/LocalLogin.vue')
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      meta: {
        title: 'forgotPassword',
        layout: 'no-header',
        meta: {
          title: 'forgotPassword'
        }
      },
      component: () =>
        import(/* webpackChunkName: "vts-login-page" */ '../views/forgotPassword/ForgotContainer')
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {
        title: 'Privacy',
        layout: 'no-header',
        meta: {
          title: 'privacy'
        }
      },
      component: () =>
        import(/* webpackChunkName: "vts-privacy-page" */ '@/views/privacy/Privacy.vue')
    },
    {
      path: '/recoverPassword',
      name: 'recoverPassword',
      meta: {
        title: 'Recover password',
        layout: 'no-header'
      },
      component: () =>
        import(/* webpackChunkName: "vts-login-page" */ '../views/recoverPassword/RecoverPassword')
    },
    {
      path: '/404',
      name: '404',
      component: () =>
        import(/* webpackChunkName: "vts-not-found-page" */ '../views/errorPages/NotFound'),
      props: true,
      meta: {
        title: 'Page not found - 404',
        layout: 'no-header'
      }
    },
    {
      path: '*',
      redirect: { name: '404', params: { resource: 'page' } }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const publicPages = [
    '/login',
    '/forgotPassword',
    '/404',
    '/network-issue',
    '/reports',
    '/ssologin',
    '/locallogin',
    '/recoverPassword',
    '/privacy'
  ]
  const loggedIn = localStorage.getItem('user')
  const authRequired = !publicPages.includes(to.path)
  if (authRequired && !loggedIn) return next('/login')
  next()
})

router.beforeEach((routeTo, from, next) => {
  NProgress.start()

  var allowedUseCasesId = []
  const userString = JSON.parse(localStorage.getItem('user'))
  if (userString != null) {
    const accessToken = userString.accessToken
    const parsedAccessToken = parseJwt(accessToken.split('.')[1])
    const userData = JSON.parse(parsedAccessToken.UserData)
    allowedUseCasesId = userData.AllowedUseCaseIds
  }
  if (routeTo.meta.title && typeof routeTo.meta.title === 'function') {
    document.title = routeTo.meta.title(routeTo)
  } else if (routeTo.meta.title) {
    document.title = routeTo.meta.title
  } else {
    document.title = 'Fleet Manager'
  }

  if (routeTo.meta.useCase) {
    var useCaseId = useCaseMap[routeTo.meta.useCase]
    if (!allowedUseCasesId.includes(useCaseId)) {
      next('/')
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
